export function filterDateTime(time) {
    if (time == null || time == "") return "";
    var date = new Date(time) 
    var year = date.getFullYear()
    var month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
    var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate() 
    var hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours() 
    var minutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes() 
    var seconds = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
    return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds
}
// export function filterYear(time) {
//     if (time == null || time == "") return "";
//     var date = new Date(time) 
//     var year = date.getFullYear()
//     return year
// }
export function filterTime(time) {
    if (time == null || time == "") return "";
    var date = new Date(time) 
    var year = date.getFullYear()
    var month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
    var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate() 
    var hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours() 
    var minutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes() 
    var seconds = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
    return hours + ':' + minutes + ':' + seconds
}
export function filterDate(time) {
    if (time == null || time == "") return "";
    var date = new Date(time) 
    var year = date.getFullYear()
    var month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
    var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate() 
    var hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours() 
    var minutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes() 
    var seconds = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
    return year + '-' + month + '-' + day
}
export function filterYearMonth(time) {
    if (time == null || time == "") return "";
    var date = new Date(time) 
    var year = date.getFullYear()
    var month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
    var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate() 
    var hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours() 
    var minutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes() 
    var seconds = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
    return year + '-' + month
}
export function filterday(time) {
    if (time == null || time == "") return "";
    var date = new Date(time) 
    var year = date.getFullYear()
    var month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
    var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate() 
    var hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours() 
    var minutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes() 
    var seconds = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
    return day
}